import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// Button v2 (CLAUDE.md): h-11, rounded-[10px], text-sm font-semibold,
// Hover wechselt NUR die Farbe (kein translateY, keine Schatten).
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[10px] text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // default = primary, Variante B (Inhaber-Entscheidung R4):
        // Füllung brand, Text ink (Navy), Hover nur dunklere Füllung
        default: "bg-brand text-ink hover:bg-brand-deep",
        primary: "bg-brand text-ink hover:bg-brand-deep",
        secondary: "bg-surface border border-line text-ink hover:bg-canvas",
        // outline-Bestandsnutzungen verhalten sich wie secondary
        outline: "bg-surface border border-line text-ink hover:bg-canvas",
        ghost: "text-ink hover:bg-canvas",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        link: "text-brand-text underline-offset-4 hover:underline",
      },
      size: {
        default: "h-11 px-6",
        sm: "h-9 px-4",
        lg: "h-11 px-8",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
